<div class="sip-manipulation-groups-summary">
  <div *ngIf="!sipManipulationGroup" class="arm-summary">0 Items selected</div>
  <div *ngIf="sipManipulationGroup" class="arm-summary">
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Name:</span>
      <span [title]="sipManipulationGroup.name" class="arm-summary-value" fxFlex>{{sipManipulationGroup.name}}</span>
    </div>
    <ac-line-separator title="Manipulations"></ac-line-separator>

    <div class="manipulations" *ngFor="let manipulation of sipManipulationGroup.manipulations; let i = index">
      <span>{{i + 1}}. </span>
      <span class="subject">{{manipulation.actionSubject}} </span>
      <span class="operator">{{manipulation.displayData?.actionType}} </span>
      <span class="values" [ngSwitch]="manipulation.actionType">
        <span *ngSwitchCase="'normalization'">{{manipulation.displayData?.normalizationGroupId}}</span>
        <span *ngSwitchCase="'randomFromPool'">{{manipulation.displayData?.prefixGroupId}}</span>
        <span *ngSwitchCase="'sendByWebService'">{{manipulation.displayData?.webServiceId}}</span>
        <span *ngSwitchDefault>{{manipulation.actionValue}}</span>
      </span>

  </div>
</div>
